var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 8.75H8.25V6.125C8.25 5.9375 8.0625 5.75 7.875 5.75H2.625C2.41406 5.75 2.25 5.9375 2.25 6.125V12.125C2.25 12.3359 2.41406 12.5 2.625 12.5H12.375C12.5625 12.5 12.75 12.3359 12.75 12.125V9.125C12.75 8.9375 12.5625 8.75 12.375 8.75ZM7.125 11.375H3.375V9.875H7.125V11.375ZM7.125 8.375H3.375V6.875H7.125V8.375ZM11.625 11.375H8.25V9.875H11.625V11.375ZM13.9922 3.10156L8.10938 0.640625C7.71094 0.476562 7.26562 0.476562 6.86719 0.640625L0.984375 3.10156C0.375 3.33594 0 3.92188 0 4.57812V12.125C0 12.3359 0.164062 12.5 0.375 12.5H0.75C0.9375 12.5 1.125 12.3359 1.125 12.125V4.57812C1.125 4.36719 1.21875 4.20312 1.40625 4.13281L7.3125 1.67188C7.42969 1.625 7.54688 1.625 7.66406 1.67188L13.5703 4.13281C13.7578 4.20312 13.875 4.36719 13.875 4.57812V12.125C13.875 12.3359 14.0391 12.5 14.25 12.5H14.625C14.8125 12.5 15 12.3359 15 12.125V4.57812C15 3.92188 14.6016 3.33594 13.9922 3.10156Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.303004c0.svg";
export { ForwardRef as ReactComponent };